export default __webpack_public_path__ + "static/paintingGoddess-46d3e5e4bc484b36862735aecfb45b02.svg";